export default __webpack_public_path__ + "213a0423ea24d035ffc9dcddfd7d09b0.png";